// extracted by mini-css-extract-plugin
module.exports = {"Blogs":"Blogs_Blogs__1F6QL"};